<nz-modal
  [nzMaskClosable]="false"
  [nzNoAnimation]="true"
  [nzVisible]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="768"
>
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <app-add-edit-event-form
      #form
      [editObject]="object"
      (formFinished)="onFormFinished($event)"
      [seminar]="seminar"
    ></app-add-edit-event-form>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Abbrechen</button>
    <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading">Speichern</button>
  </ng-template>
</nz-modal>
